import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    confirmLabel: 'Apply',
    invitationConfirmation: 'The invitation has been sent to {firstName}',
    roleAppliedConfirmation: 'The new role has been applied to {firstName}',
  },
  fr: {
    confirmLabel: 'Appliquer',
    invitationConfirmation: 'L’invitation a bien été envoyée à {firstName}',
    roleAppliedConfirmation: 'Le nouveau rôle a été appliqué à {firstName}',
  },
} as const);

export default locales;
